import React from 'react'


export const NavbarItemDivider = function(props) {
    return (
        <hr className="navbar-divider" />
    )
}

export default NavbarItemDivider



// WEBPACK FOOTER //
// ./src/nav/NavbarItemDivider.js